import React from 'react';
import { CONTENT_FORMAT_OPTIONS, contentFormatLabel } from '../../utils/brand-content-format';

/** Nhãn định dạng trên thẻ chiến dịch/brief/lời mời. Chiến dịch cũ (không có định dạng) không hiện gì. */
const ContentFormatBadge: React.FC<{ format?: string | null }> = ({ format }) => {
  const label = contentFormatLabel(format);
  if (!label) return null;
  return (
    <span className="ui-divider inline-flex shrink-0 items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold ui-text">
      {label}
    </span>
  );
};

/** Ô lọc định dạng ở sàn chiến dịch và sàn brief. */
export const ContentFormatFilter: React.FC<{ value: string; onChange: (value: string) => void }> = ({ value, onChange }) => (
  <select
    aria-label="Lọc theo định dạng"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className="rounded-md border ui-divider bg-transparent px-2 py-1.5 text-[13px] outline-none ui-text"
  >
    <option value="">Mọi định dạng</option>
    {CONTENT_FORMAT_OPTIONS.map((o) => (
      <option key={o.value} value={o.value}>
        {o.label}
      </option>
    ))}
  </select>
);

export default ContentFormatBadge;
